import Example from "./Example";

const ExampleConfig = {
	settings: {
		layout: {},
	},
	routes: [
		{
			path: "example",
			element: <Example />,
		},
	],
};

export default ExampleConfig;

/**
 * Lazy load Example
 */
/*
import React from 'react';

const Example = lazy(() => import('./Example'));

const ExampleConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'example',
      element: <Example />,
    },
  ],
};

export default ExampleConfig;
*/
